import { useRecoilValue } from 'recoil'
import userAtom from '@/pages/User/user.atom.ts'

const useIsAdmin = () => {
  const user = useRecoilValue(userAtom)

  return user.isAdmin
}

export default useIsAdmin
